<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
     <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Documents</span
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/document/index">Manage Documents</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><span class="decoration">Bulk Upload</span
        >
      </h6>

      <div class="container-fluid">
        <div class="card bdr-rad2 mt-1 shadow p-2">
          <div class="card-body">
            <form @submit.prevent="createBulk">
              <div v-if="message" class="alert alert-success py-2">
                {{ message }}
              </div>
              <div v-if="errorMessage" class="alert alert-danger py-2">
                {{ errorMessage }}
              </div>

              <div class="row align-items-stretch mb-3">
                <div class="col-md-6 mb-3 mb-md-0">
                  <div class="card custom_bdr_rds h-100">
                    <div class="card-body custom_bdr_rds">
                      <h6 class="purchitem mb-2"><b>Upload Folder</b></h6>
                      <label class="custom-label" style="font-size: small"
                        >Select folder files
                        <span class="text-danger">*</span></label
                      >
                      <input
                        type="file"
                        webkitdirectory
                        directory
                        multiple
                        required
                        @change="selectFiles"
                        class="form-control form-control-sm bdr-rad font-size_def"
                      />
                      <div v-if="files.length" class="mt-2">
                        <b>{{ files.length }} file(s) selected</b>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card custom_bdr_rds h-100">
                    <div class="card-body custom_bdr_rds">
                      <h6 class="purchitem mb-2"><b>Add New Meta Fields</b></h6>
                      <div
                        v-for="(field, index) in templateFields"
                        :key="field.key"
                        class="border-bottom pb-1 mb-1"
                        style="display: flex; align-items: center; flex-wrap: nowrap; width: 100%;"
                      >
                        <input
                          v-model="field.name"
                          class="form-control form-control-sm bdr-rad"
                          style="flex: 1 1 auto; min-width: 0;"
                          placeholder="Field name"
                        />
                        <div style="display: flex; align-items: center; justify-content: center; flex: 0 0 45px; width: 45px; margin-left: 8px;">
                          <b-icon
                            @click="removeTemplateField(index)"
                            class="mt-2"
                            width="8"
                            icon="dash-lg"
                            type="button"
                            scale="2"
                          ></b-icon>
                        </div>
                      </div>
                      <div class="input-group input-group-sm">
                        <input
                          v-model="newFieldName"
                          @keyup.enter="addTemplateField"
                          class="form-control form-control-sm font-size_def"
                          placeholder="New field name"
                        />
                        <div class="input-group-append ms-2" style="flex: 0 0 45px; width: 45px;">
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                            @click="addTemplateField"
                          >
                            Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="documents.length"
                class="table-responsive mb-1"
                style="
                  width: 100%;
                  max-width: 100%;
                  overflow-x: auto;
                  overflow-y: hidden;
                "
              >
                <table
                  style="
                    font-size: small;
                    min-width: 2200px;
                    width: max-content;
                  "
                  class="table table-sm table-hover"
                >
                  <thead class="background_color2">
                    <tr class="custom-label2">
                      <th style="width: 180px; min-width: 180px">
                        PDF / File Name
                      </th>
                      <th style="min-width: 145px">
                        Document Title <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        People <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Document Type <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Company <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Department <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Branch <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Privacy Level <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Project <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Partner <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">
                        Template <span class="text-danger">*</span>
                      </th>
                      <th style="min-width: 145px">Permission Group</th>
                      <th style="min-width: 145px">Publisher</th>
                      <th style="min-width: 120px">Status</th>
                      <th
                        v-for="field in templateFields"
                        :key="field.key"
                        style="min-width: 145px"
                      >
                        {{ field.name || "Template Field" }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="document in documents" :key="document.key">
                      <td style="width: 180px; min-width: 180px">
                        {{ document.file.name
                        }}<small class="d-block text-muted">{{
                          formatSize(document.file.size)
                        }}</small>
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.job_title"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <select
                          v-model="document.employee_id"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        >
                          <option value="">Select People</option>
                          <option
                            v-for="employee in employees"
                            :key="employee.id"
                            :value="employee.id"
                          >
                            {{ employee.label }}
                          </option>
                        </select>
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.document_type"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.company"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.department"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.branch"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <select
                          v-model="document.privacy_level"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        >
                          <option value="">Select Privacy</option>
                          <option>Public</option>
                          <option>Internal</option>
                          <option>Confidential</option>
                          <option>Restricted</option>
                        </select>
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.project"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.partner"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.template"
                          required
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          v-model="document.permission_group"
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                      <td style="min-width: 145px">
                        <input
                          value="Manual Upload"
                          readonly
                          class="form-control form-control-sm bdr-rad font-size_def bg-light"
                        />
                      </td>
                      <td style="min-width: 120px">
                        <input
                          value="Published"
                          readonly
                          class="form-control form-control-sm bdr-rad font-size_def bg-light"
                        />
                      </td>
                      <td
                        v-for="field in templateFields"
                        :key="field.key"
                        style="min-width: 145px"
                      >
                        <input
                          v-model="document.templateValues[field.key]"
                          :placeholder="field.name || 'Value'"
                          class="form-control form-control-sm bdr-rad font-size_def"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="text-right mt-3">
                <router-link
                  class="btn btn-sm btn-outline-secondary mr-2 bdr-rad font-size_def"
                  to="/document/index"
                  >Cancel</router-link
                >
                <button
                  type="submit"
                  class="btn btn-sm btn-outline-primary bdr-rad font-size_def"
                  :disabled="!documents.length"
                >
                  Create Bulk
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ContentFooter></ContentFooter>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

const emptyDocument = (file) => ({
  key: Date.now() + Math.random(),
  file,
  job_title: "",
  employee_id: "",
  document_type: "",
  company: "",
  department: "",
  branch: "",
  privacy_level: "",
  project: "",
  partner: "",
  template: "",
  permission_group: "",
  templateValues: {},
});

export default {
  name: "DocumentBulkCreate",
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      employees: [],
      files: [],
      documents: [],
      templateFields: [],
      newFieldName: "",
      message: "",
      errorMessage: "",
    };
  },
  mounted() {
    this.loadEmployees();
  },
  methods: {
    async loadEmployees() {
      try {
        const response = await axios.get("/document/employees", {
          headers: { Authorization: `Bearer ${this.token}` },
        });
        this.employees = (response.data.data || []).map((employee) => ({
          id: employee.id,
          label: `${employee.fin_nric ? employee.fin_nric + " - " : ""}${
            employee.name
          }`,
        }));
      } catch (error) {
        this.errorMessage = "Unable to load people.";
      }
    },
    selectFiles(event) {
      this.files = Array.from(event.target.files || []);
      this.documents = this.files.map(emptyDocument);
      this.message = "";
      this.errorMessage = "";
    },
    formatSize(size) {
      if (!size) return "0 KB";
      return `${Math.max(1, Math.round(size / 1024))} KB`;
    },
    addTemplateField() {
      const name = this.newFieldName.trim();
      if (!name) return;
      const field = { key: Date.now() + Math.random(), name };
      this.templateFields.push(field);
      this.documents.forEach((document) =>
        this.$set(document.templateValues, field.key, "")
      );
      this.newFieldName = "";
    },
    removeTemplateField(index) {
      const field = this.templateFields[index];
      if (!field) return;
      this.templateFields.splice(index, 1);
      this.documents.forEach((document) =>
        this.$delete(document.templateValues, field.key)
      );
    },
    async createBulk() {
      this.message = "";
      this.errorMessage = "";
      const formData = new FormData();
      const payload = {
        documents: this.documents.map((document) => ({
          ...document,
          templateValues: undefined,
          template_fields: this.templateFields
            .map((field) => ({
              name: field.name,
              value: document.templateValues[field.key] || "",
            }))
            .filter((field) => field.name || field.value),
        })),
      };
      formData.append("payload", JSON.stringify(payload));
      this.files.forEach((file, index) =>
        formData.append(`assignment_files[${index}]`, file)
      );
      try {
        await axios.post("/document/bulk-create", formData, {
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        this.$router.push("/document/index");
      } catch (error) {
        this.errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Bulk document creation failed.";
      }
    },
  },
};
</script>
